import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hr',
  months: [
    'siječnja',
    'veljače',
    'ožujka',
    'travnja',
    'svibnja',
    'lipnja',
    'srpnja',
    'kolovoza',
    'rujna',
    'listopada',
    'studenoga',
    'prosinca',
  ],
  monthsShort: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
  weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
  weekdaysMin: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  weekdaysShort: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D. M. YYYY.',
    LL: 'D. MMMM YYYY.',
    'LL-D': 'MMMM YYYY.',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY. HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY. HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D. M. YYYY.',
    'l-Y': 'D. M.',
    ll: 'D. MMM YYYY.',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY.',
    lll: 'D. MMM YYYY. HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd D. MMM YYYY. HH:mm',
    'llll-Y': 'ddd D. MMM HH:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY. HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: 'prije %s godinu', few: 'prije %s godine', other: 'prije %s godina' },
    M: { one: 'prije %s mjesec', few: 'prije %s mjeseca', other: 'prije %s mjeseci' },
    w: { one: 'prije %s tjedan', few: 'prije %s tjedna', other: 'prije %s tjedana' },
    d: { one: 'prije %s dan', few: 'prije %s dana', other: 'prije %s dana' },
    h: { one: 'prije %s sat', few: 'prije %s sata', other: 'prije %s sati' },
    m: { one: 'prije %s minutu', few: 'prije %s minute', other: 'prije %s minuta' },
    s: { one: 'prije %s sekundu', few: 'prije %s sekunde', other: 'prije %s sekundi' },
  },
  future: {
    y: { one: 'za %s godinu', few: 'za %s godine', other: 'za %s godina' },
    M: { one: 'za %s mjesec', few: 'za %s mjeseca', other: 'za %s mjeseci' },
    w: { one: 'za %s tjedan', few: 'za %s tjedna', other: 'za %s tjedana' },
    d: { one: 'za %s dan', few: 'za %s dana', other: 'za %s dana' },
    h: { one: 'za %s sat', few: 'za %s sata', other: 'za %s sati' },
    m: { one: 'za %s minutu', few: 'za %s minute', other: 'za %s minuta' },
    s: { one: 'za %s sekundu', few: 'za %s sekunde', other: 'za %s sekundi' },
  },
  pastLong: {
    y: { one: 'prije %s godinu', few: 'prije %s godine', other: 'prije %s godina' },
    M: { one: 'prije %s mjesec', few: 'prije %s mjeseca', other: 'prije %s mjeseci' },
    w: { one: 'prije %s tjedan', few: 'prije %s tjedna', other: 'prije %s tjedana' },
    d: { one: 'prije %s dan', few: 'prije %s dana', other: 'prije %s dana' },
    h: { one: 'prije %s sat', few: 'prije %s sata', other: 'prije %s sati' },
    m: { one: 'prije %s minutu', few: 'prije %s minute', other: 'prije %s minuta' },
    s: { one: 'prije %s sekundu', few: 'prije %s sekunde', other: 'prije %s sekundi' },
  },
  futureLong: {
    y: { one: 'za %s godinu', few: 'za %s godine', other: 'za %s godina' },
    M: { one: 'za %s mjesec', few: 'za %s mjeseca', other: 'za %s mjeseci' },
    w: { one: 'za %s tjedan', few: 'za %s tjedna', other: 'za %s tjedana' },
    d: { one: 'za %s dan', few: 'za %s dana', other: 'za %s dana' },
    h: { one: 'za %s sat', few: 'za %s sata', other: 'za %s sati' },
    m: { one: 'za %s minutu', few: 'za %s minute', other: 'za %s minuta' },
    s: { one: 'za %s sekundu', few: 'za %s sekunde', other: 'za %s sekundi' },
  },
  abbr: {
    y: { one: '%s godina', few: '%s godine', other: '%s godina' },
    M: { one: '%s mjesec', few: '%s mjeseca', other: '%s mjeseci' },
    w: { one: '%s tjedan', few: '%s tjedna', other: '%s tjedana' },
    d: { one: '%s dan', few: '%s dana', other: '%s dana' },
    h: { one: '%s sat', few: '%s sata', other: '%s sati' },
    m: { one: '%s minuta', few: '%s minute', other: '%s minuta' },
    s: { one: '%s sekunda', few: '%s sekunde', other: '%s sekundi' },
  },
  full: {
    y: { one: '%s godina', few: '%s godine', other: '%s godina' },
    M: { one: '%s mjesec', few: '%s mjeseca', other: '%s mjeseci' },
    w: { one: '%s tjedan', few: '%s tjedna', other: '%s tjedana' },
    d: { one: '%s dan', few: '%s dana', other: '%s dana' },
    h: { one: '%s sat', few: '%s sata', other: '%s sati' },
    m: { one: '%s minuta', few: '%s minute', other: '%s minuta' },
    s: { one: '%s sekunda', few: '%s sekunde', other: '%s sekundi' },
  },
  justNow: 'upravo',
  yesterday: 'jučer',
  today: 'danas',
  tomorrow: 'sutra',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s (%$2s)',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY.', end: 'D. MMMM YYYY.' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY.' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'DD.', end: 'DD. MMMM YYYY.' },
    dl: { start: 'DD.', end: 'DD. MMMM' },
    y: { start: 'DD. MMM YYYY.', end: 'DD. MMM YYYY.' },
    'y-1': { start: 'DD. MMM', end: 'DD. MMM YYYY.' },
    m: { start: 'DD. MMM', end: 'DD. MMM' },
    'm-1': { start: 'DD.', end: 'DD. MMM YYYY.' },
    d: { start: 'DD.', end: 'DD. MMM' },
    Y: { start: 'ddd, DD. MMM YYYY.', end: 'ddd, DD. MMM YYYY.' },
    'Y-1': { start: 'ddd, DD. MMM', end: 'ddd, DD. MMM YYYY.' },
    M: { start: 'ddd, DD. MMM', end: 'ddd, DD. MMM' },
    D: { start: 'ddd, DD. MMM', end: 'ddd, DD. MMM' },
    yt: { start: 'DD. MMM YYYY. HH:mm', end: 'DD. MMM YYYY. HH:mm' },
    mt: { start: 'DD. MMM HH:mm', end: 'DD. MMM HH:mm' },
    dt: { start: 'DD. MMM HH:mm', end: 'DD. MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'DD. MMM YYYY. HH:mm', end: 'DD. MMM YYYY. HH:mm ([GMT]Z)' },
    'mt+to': { start: 'DD. MMM HH:mm', end: 'DD. MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'DD. MMM HH:mm', end: 'DD. MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'hr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
